<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M10 16L14 12L10 8" stroke="#C4DDFF" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14 12H5" stroke="#C4DDFF" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14 5H17.3333C17.7754 5 18.1993 5.16389 18.5118 5.45561C18.8244 5.74733 19 6.143 19 6.55556V17.4444C19 17.857 18.8244 18.2527 18.5118 18.5444C18.1993 18.8361 17.7754 19 17.3333 19H14" stroke="#C4DDFF" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>